import { useEffect, useState } from "react";
import { useEditState } from "../EditContext";
import { Poi } from "../../../types";
import SpinnerWrapper from "../BaseComponents/SpinnerWrapper";
import { useParams } from "react-router-dom";
import { useAppState } from "../../../AppContext";
import PoiEditor from "./PoiEditor";

const SinglePoiPage: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [poi, setPoi] = useState<Poi>();
  const { target, setTarget, panoRepository } = useEditState();
  const { state } = useAppState();
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    if (id) {
      setTarget(Number(id));
    }
  }, [id, setTarget]);
  
  /* Fetch metadata for panorama. */
  useEffect(() => {
    if (target) {
      setLoading(true);
      const data = state.pois.find((poi) => poi.id === target);
      setPoi(data);
      setLoading(false);
    }
  }, [panoRepository, state.pois, target]);

  return (
    <SpinnerWrapper loading={loading}>
      {poi && <PoiEditor poi={poi} />}
    </SpinnerWrapper>
  );
};

export default SinglePoiPage;
